import {useAuth} from "../../context/authContext";
import ActionsMenu from "../action-buttons/ActionsMenu";
import {FC} from "react";
import {FeedbacksListProps} from "./types";
import {List, Rate, Tag, Typography} from "antd";
import dayjs from "dayjs";
import {DATE_FORMATS} from "../../enums/dateFormats";
import {FeedbackItem} from "../../types/feedback";

const FeedbacksList: FC<FeedbacksListProps> = (props) => {
  const {canManageContent} = useAuth();
  const {feedbacksList, isLoading, confirmDeleteFeedback} = props

  const getListItemActions = (feedback: FeedbackItem) => {
    return [<ActionsMenu key="actions" onDelete={() => {
      confirmDeleteFeedback({id: feedback.$id || ""})
    }}/>]
  }

  const {Text} = Typography;
  return <List
    loading={isLoading}
    bordered
    dataSource={feedbacksList}
    renderItem={(item) => (
      <List.Item extra={canManageContent ? getListItemActions(item) : undefined}>
        <div style={{width: "100%"}}>
          <Tag>{item.author}</Tag>
          <div>
            <Text>{item.feedback}</Text>
          </div>
          <div style={{marginTop: 8}}>
            <Rate disabled value={item.rate}/>
          </div>
          <div style={{marginTop: 8}}>
            <Text
              type="secondary">{item.$createdAt ? dayjs(item.$createdAt).format(DATE_FORMATS.DATE_WITH_TIME) : ""}</Text>
          </div>
        </div>
      </List.Item>
    )}
  />
}

export default FeedbacksList